export function formatInrFromPaise(paise) {
  if (!paise) return "Contact us";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(paise / 100);
}

export function validateRegistrationForm(values) {
  const errors = {};
  if (!values.company_name?.trim()) errors.company_name = "Company name is required";
  if (!values.email?.trim()) errors.email = "Email is required";
  if (!/^[6-9]\d{9}$/.test(String(values.mobile || "").replace(/\D/g, "").slice(-10))) {
    errors.mobile = "Valid 10-digit mobile required";
  }
  if (!values.password || values.password.length < 8) {
    errors.password = "Password must be at least 8 characters";
  }
  if (!values.plan_slug) errors.plan_slug = "Select a plan";
  return errors;
}
